import {
  type ShareLinkThumbnailRadius,
  THUMBNAIL_RADIUS_DEFAULT,
} from '~/components/v2/components/shared/share-link-design/shareLinkThumbnailRadius';

/*
 * Board-cover corner classes for the public board page's cover band (PublicBoardCover), keyed by
 * the full wire union like shareLinkThumbnailRadius's page-chrome maps so a new union member is a
 * type error here. The cover is page chrome — a band inside the content column, the surface the
 * designer prototype rounded with its page-corner radius — NOT a gallery card, so it follows a
 * chrome-style class map rather than the gallery card vars (whose values carry the cards'
 * concentric inner-radius contract). It gets its own board-side map instead of reusing
 * SHARE_LINK_PAGE_CORNER_CLASSES because the cover shipped with its own 8px rounding (BoardCover's
 * native `rounded-8`), not the column's 12px: `standard` is deliberately `undefined` — emitting no
 * class keeps a legacy link's cover class list byte-identical to today (same default-as-no-op
 * contract as the gallery card radius vars). `subtle` coincides with the native 8px; `square`
 * squares the cover alongside the page chrome. A wire value newer than the compiled union resolves
 * through THUMBNAIL_RADIUS_DEFAULT to `undefined` — the native radius, the same safe degradation
 * as the card vars.
 */
const BOARD_COVER_CORNER_CLASSES: Record<ShareLinkThumbnailRadius, string | undefined> = {
  standard: undefined,
  subtle: 'rounded-8',
  square: 'rounded-none',
};

/** Corner class for the public board page's cover band — follows the Corner rounding design setting. */
export const getBoardCoverCornerClass = (thumbnailRadius: ShareLinkThumbnailRadius | undefined): string | undefined =>
  BOARD_COVER_CORNER_CLASSES[thumbnailRadius ?? THUMBNAIL_RADIUS_DEFAULT];
